import Dummy from "components/Dummy";
import P from "components/P";
import style from "./SlideGuide.module.css";
import slideHandleIcon from "resources/img/puffu/main/slideHandle.svg";
import { useTouchClick } from "shared/hooks/useTouchClick";

function SlideGuide(props) {
    const { setViewData } = props;
    
    const onClick = () => {
        setViewData((prevData) => ({
            ...prevData,
            slideGuide: false
        }));
    };

    // 전체 오버레이에 터치 이벤트 등록
    const { handleTouchStart: overlayTouchStart, handleTouchEnd: overlayTouchEnd } = useTouchClick(() => onClick(), 10);

    // 안내 메시지 자체에는 터치 이벤트 전파를 막음
    const { handleTouchStart: messageTouchStart, handleTouchEnd: messageTouchEnd } = useTouchClick(() => {}, 10);

    return (
        <div className={style.overlay} onPointerDown={overlayTouchStart} onPointerUp={overlayTouchEnd}>
            <div className={style.downAngleContainer} onPointerDown={messageTouchStart} onPointerUp={messageTouchEnd}>
                {/* 기존의 SlideGuide 내용 */}
                <div className={style.dash2} />
                <div className={style.dash3} />
                <div className={style.dash4} />
                <div className={style.dash5} />
                <img src={slideHandleIcon} width={"40%"} style={{ filter: "invert(100%)" }} className={style.handleIcon} />
                <Dummy height={"25px"} />
                <P textAlign={"center"} weight={700} size={24} color={"white"}>슬라이드해서 넘겨보세요</P>
                <P textAlign={"center"} weight={700} size={16} color={"white"}>(터치 시 사라집니다)</P>
            </div>
        </div>
    );
}

export default SlideGuide;
